export const reportList = [
    {
        nepali: "जनसंख्या सम्बन्धी",
        english: "Population Related",
        value: "populationReport",
        baseApiKey: "family-detail",
        child: [
            {
                nepali: "उमेर अनुसार जनसंख्या",
                english: "Age wise population info",
                value: "age",
                title: "family",
                table: "genderWise",
            },
            {
                nepali: "घरमुली अनुसार विवरण",
                english: "House Owner Detail",
                value: "houseOwnerGender",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "वडागत घरधुरी संख्या तथा लिङ्गको आधारमा जनसंख्या",
                english: "",
                value: "populationInfo",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "वडा अनुसार उमेर समूह विवरण",
                english: "Age wise population info",
                value: "ageWardWise",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "बसोबासको अवस्था",
                english: "Living Status",
                value: "livingtype",
                title: "family",
                table: "wardWise",
            },
            // {
            // 	nepali: "अनुपस्थित जनसंख्या भएका परिवार संख्याको विवरण",
            // 	english: "",
            // 	value: "livingTypeDetail",
            // 	title: "family",
            // 	table: "wardWise",
            // },
            {
                nepali: "स्वदेश अन्यत्र",
                english: "Same Place",
                value: "livingSamePlace",
                title: "family",
                table: "wardWise",
            },
            // {
            // 	nepali: "परिवारको सदश्य वैदेशिक बसाईको आधारमा",
            // 	english: "",
            // 	value: "familyLivingAbroad",
            // 	title: "family",
            // 	table: "wardWise",
            // },
            {
                nepali: "विदेश गएको देश",
                english: "Foreign Country",
                value: "abroad",
                title: "family",
                table: "genderWise",
            },
            {
                nepali: "विदेश गएको अवधिको आधारमा जनसंख्या विवरण",
                english: "Abroad age",
                value: "abroadAge",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "विदेशमा वस्ने सदश्य संख्याको आधारमा",
                english: "Foreign Country",
                value: "abroadPopulation",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "विदेश गएको कारण",
                english: "Abroad Reason",
                value: "abroadReason",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "जातजाति अनुसार जनसंख्या",
                english: "Caste Report",
                value: "ethnics",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "धर्म अनुसार जनसंख्या",
                english: "Religion Report",
                value: "religion",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "मातृभाषा अनुसार जनसंख्या",
                english: "Mother tounge Report",
                value: "mothertongue",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "शैक्षिकस्तर अनुसार विवरण",
                english: "Education Report (more than 4 years)",
                value: "education",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "हाल विद्यालय जाने/नजाने",
                english: "School going/notgoing Report (4 - 16 years)",
                value: "isSchoolGoing",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "विद्यालय जानु हुन्छ भने कहाँ जानुहुन्छ",
                english: "",
                value: "isSchoolGoingWhere",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "विद्यालय जानु हुन्न भने किन जानु हुन्न",
                english: "School going/notgoing Report (4 - 16 years)",
                value: "ifNotSchoolGoing",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "जिल्ला बाहिरहो भने सामुदायिक वा निजि विद्यालयमा",
                english: "",
                value: "schoolGoingOutside",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "विद्यालय बिचैमा छोडेको हो भने कारण",
                english: "",
                value: "leavingSchoolInBetween",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "पाँचबर्ष भन्दा माथिको साक्षरता विवर",
                english: "",
                value: "aboveFiveYearLiterate",
                title: "family",
                table: "wardWise",
            },
            // {
            // 	nepali: "५-२४ उमेर समूहका जनसंख्यामा हाल स्कुल नजाने",
            // 	english: "(5 - 24 years)",
            // 	value: "ageWiseIsSchool",
            // 	title: "family",
            // 	table: "wardWise",
            // },
            {
                nepali: "अध्ययनको क्षेत्र",
                english: "Study Field",
                value: "educationSector",
                title: "family",
                table: "educationTable",
            },
            {
                nepali: "पेशा सम्बन्धि विवरण",
                english: "Occupation Report (10 years above)",
                value: "occupation",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "आर्थिक रुपले सक्रिय जनसंख्या विवरण",
                english: "Education Report (more than 4 years)",
                value: "employedPopulation",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "ज्याला/ मजदुरीको विवरण",
                english: "",
                value: "laborWork",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "स्थाई लेखा नं. (प्यान नम्बर ) छ कि छैन",
                english: "",
                value: "hasPanNumber",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "मतदाता परिचय पत्र",
                english: "",
                value: "voterCard",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "वैवाहिक स्तिथि",
                english: "Marriage Report",
                value: "martial",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "वाल विवाहा भएका वाल वालिका वा युवायुवती संख्या",
                english: "",
                value: "earlyMarriage",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "प्रथम पटक विवाह गरेको उमेर अनुसार",
                english: "First marriage age Report",
                value: "firstMarriageAge",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "परिवारका सदस्यहरुको स्वास्थ्य अवस्थाको आधारमा",
                english: "Health Condition Report",
                value: "health",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "दिर्घ रोगको किसिमको आधारमा",
                english: "Unhealthy Condition Report",
                value: "unHealthy",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "अपांगता भएको/नभएको आधारमा जनसंख्या विवरण",
                english: "Disable yes/no Report",
                value: "disableYesNo",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "अपांगता हुनुको कारण अनुसार",
                english: "Disable Reason Report",
                value: "disableReason",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "अपांगताको किसिमको आधारमा",
                english: "Disable Type Report",
                value: "disable",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "सामाजिक सुरक्षा भत्ता अनुसार जनसंख्या",
                english: "Social Welfare Report",
                value: "disableSSF",
                title: "family",
                table: "wardWise",
            },
            // {
            // 	nepali: "अपांगता कार्ड प्राप्त अनुसार जनसंख्या विवरण",
            // 	english: "Disable Card Yes/No Report",
            // 	value: "disableCardYesNo",
            // 	title: "family",
            // 	table: "wardWise",
            // },
            // {
            // 	nepali: "अपांगताको कार्डको प्रकारको आधारमा",
            // 	english: "Disable Card Type Report",
            // 	value: "disableCards",
            // 	title: "family",
            // 	table: "wardWise",
            // },
            {
                nepali: "व्यावसायिक शिप/तालिम लिएको/नलिएको आधारमा",
                english: "Skill Yes/No Report",
                value: "skillYesNo",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "शिप/तालिमको प्रकारको आधारमा",
                english: "Skill Report",
                value: "skill",
                title: "family",
                table: "wardWise",
            },
            {
                nepali:
                    "शिपमुलक तालिम लिए पश्चात सोही क्षेत्रम काम गर्दै हुनु हुन्छको आधारमा",
                english: "",
                value: "isWorkFromSkill",
                title: "family",
                table: "wardWise",
            },
            // {
            // 	nepali: "काम नगर्नुहुनेको विवरण",
            // 	english: "",
            // 	value: "workFromSkill",
            // 	title: "family",
            // 	table: "wardWise",
            // },
            {
                nepali: "नागरिकता छ वा छैनको आधारमा (१६ वर्ष माथि)",
                english: "VoterId Report",
                value: "hasCitizenship",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "राष्ट्रिय परिचय पत्र छ कि छैन",
                english: "VoterId Report",
                value: "hasNationalId",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "सामाजिक सुरक्षा कोष परिचय पत्र छ वा छैन",
                english: "VoterId Report",
                value: "hasSocialSecurityFund",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "विमा गरेको/नगरेको आधारमा",
                english: "Insurance Yes/No Report",
                value: "isInsurance",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "विमाको प्रकारको आधारमा",
                english: "Insurance Type Report",
                value: "insurance",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "जन्म दर्ता भएको/नभएको आधारमा",
                english: "Birth Certificate",
                value: "isBirthCertificate",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "जन्म दर्ता नगरेको करणको आधारमा",
                english: "Birth Certificate",
                value: "noBirthCertificate",
                title: "family",
                table: "birthCertificate",
            },
            {
                nepali: "रगत समुहको आधारमा विवरण",
                english: "Blood Group Report",
                value: "bloodGroup",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "सवारी चालक अनुमति प्रमाण पत्रको आधारमा विवरण",
                english: "Driving License Report",
                value: "drivingLicense",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "कोभिड १९ बिरुद्द खोप लिएको छ कि छैन",
                english: "",
                value: "covidVaccineYesNo",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "कोभिड १९ खोप लिएको छ भने कुन डोज लिएको छ",
                english: "",
                value: "covidDoseName",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "कृषि कार्यको क्षेत्र",
                english: "",
                value: "occupationArea",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "व्यावसायिक कृषिमा सगलग्न",
                english: "",
                value: "occupationAgriculture",
                title: "family",
                table: "wardWise",
            },
            // {
            // 	nepali: "परिवारमा रहेको सदश्य संख्याको आधारमा परिवारको विवरण",
            // 	english: "Family Count Report",
            // 	value: "familyCount",
            // 	title: "house",
            // 	table: "wardWise",
            // },
        ],
    },
    {
        nepali: "मृत्यु सम्बन्धि",
        english: "Death Report",
        value: "deathReport",
        baseApiKey: "family-detail",
        child: [
            {
                nepali:
                    "मृत्यु भएका परिवारका सदस्यहरुको संख्याको आधारमा घरधुरी विवरण",
                english: "Death of family member house count",
                value: "deathTotal",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "उमेर र लिङ्ग अनुसार मृत्यु संख्याको विवरण",
                english: "Death of family member age wise count",
                value: "deathAge",
                title: "family",
                table: "genderWise",
            },
            {
                nepali: "मृत्युको कारण अनुसार",
                english: "Death of family cause/disease wise count",
                value: "deathDisease",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "मृत्यु रोग लागेर हो भने कुन रोग",
                english: "Death Certificate",
                value: "deathDiseaseType",
                title: "family",
                table: "wardWise",
            },
            {
                nepali: "मृत्यु दर्ता सम्बन्धी",
                english: "Death Certificate",
                value: "deathCertificate",
                title: "family",
                table: "wardWise",
            },
            // {
            // 	nepali:
            // 		"दर्ता गरेको छ भने मृत्यु भएको ३५ दिन भित्र गर्नु भएको हो वा ३५ दिन भन्दा पछाडी",
            // 	english: "Death Certificate",
            // 	value: "deathCertificateTime",
            // 	title: "family",
            // 	table: "wardWise",
            // },
        ],
    },
    {
        nepali: "परिवारले प्रयोग गर्ने",
        english: "Family Related Detail",
        value: "familyReport",
        baseApiKey: "house-detail",
        child: [
            {
                nepali: "परिवारको यहाको बसोबास विवरण",
                english: "",
                value: "livingStatus",
                title: "house",
                table: "wardWise",
            },
            {
                nepali:
                    "खाना पकाउन प्रयोगहुने प्रमुख ईन्धन चुलोको आधारमा घरधुरी विवरण",
                english:
                    "Household details based on the main fuel stove used for cooking",
                value: "cookingSource",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "घरमा कस्तो प्रकारको चुलो प्रयोग गर्नु हुन्छ ?",
                english: "",
                value: "stoveDetail",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "खाने पानीको आधारमा",
                english: "Based on drinking water",
                value: "waterresource",
                title: "house",
                table: "wardWise",
            },
            // {
            // 	nepali:
            // 		"परिवारले प्रयोग गरेको पिउने पानीको स्रोत बर्षभरि कति महिनाको लागि हुन्छ",
            // 	english: "Based on drinking water",
            // 	value: "waterForMonth",
            // 	title: "house",
            // 	table: "wardWise",
            // },
            {
                nepali: "पानि लिनजना, भर्ना र फर्कन लाग्ने समय अवधि",
                english: "Period of water intake, admission and return",
                value: "distanceToWaterSource",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "पिउने पानीको शुद्धिकरण",
                english: "Purification of drinking water",
                value: "waterPurification",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "बत्तीको मुख्य श्रोत",
                english: "Main source of light",
                value: "electricSource",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "विधुतीय मिटर जडान",
                english: "electricity meter",
                value: "isElectricityMeter",
                title: "house",
                table: "wardWise",
            },
            {
                nepali:
                    "घरमा बिजुलीको मिटर जडान गर्नु भएको छैन भने किन जडान नगरेको",
                english: "no electricity",
                value: "noElectricity",
                title: "house",
                table: "wardWise",
            },
            // {
            // 	nepali: "नुनको प्रयोग सम्बन्धी",
            // 	english: "Salt Used",
            // 	value: "saltUsed",
            // 	title: "house",
            // 	table: "wardWise",
            // },
            // {
            // 	nepali: "शौचालय भएको/नभएको विवरण",
            // 	english: "Details of having / not having toilet",
            // 	value: "isToilet",
            // 	title: "house",
            // 	table: "wardWise",
            // },
            {
                nepali: "शौचालयको किसिम",
                english: "Type of toilet",
                value: "toilet",
                title: "house",
                table: "wardWise",
            },
            // {
            // 	nepali: "शौचालय नभएको कारण",
            // 	english: "Due to lack of toilet",
            // 	value: "noToilet",
            // 	title: "house",
            // 	table: "wardWise",
            // },
            {
                nepali: "तपाईको घरमा हप्तामा कति फोहरमैला उत्पादन हुन्छ ?",
                english: "Garbage coming out of the house",
                value: "wasteProduction",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "घरबाट निस्किने फोहोरमैला विवरण",
                english: "Garbage coming out of the house",
                value: "garbage",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "घर सम्म कस्तो सतह ढलको व्यवस्था",
                english: "Condition of the road leading to the house",
                value: "drainManagement",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "घर सम्म पुग्ने सडक/बाटोको अवस्था",
                english: "Condition of the road leading to the house",
                value: "road",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "परिवारले प्रयोग गर्ने सुविधाहरुको विवरण",
                english: "Details of facilities used by the family",
                value: "houseFacility",
                title: "house",
                table: "wardWise",
            },
            // {
            // 	nepali: "८.१ मोटरसाइकल/स्कुटर - संख्या",
            // 	english: "Motor Cycle Count",
            // 	value: "motorCycleCount",
            // 	title: "house",
            // 	table: "wardWise",
            // },
        ],
    },
    {
        nepali: "घर सम्बन्धि विवरण",
        english: "House Related Detail",
        value: "houseReport",
        baseApiKey: "house-detail",
        child: [
            {
                nepali: "घरको संख्याको आधारमा विवरण",
                english: "Details based on the number of houses",
                value: "houseCount",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "एक भन्दा बेसी घर भए अर्को घर कहाँ भएको विवरण",
                english: "Details based on the number of houses",
                value: "houseMoreThanOne",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "घरको तल्लाको आधारमा विवरण",
                english: "Details based on the floor of the house",
                value: "totalStorey",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "घरको कोठा संख्याको आधारमा विवरण",
                english: "Details based on the number of rooms in the house",
                value: "totalRoom",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "घर निर्माण वर्षको आधारमा विवरण",
                english: "Details based on age of house",
                value: "houseAge",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "घरको स्वामित्व आधारमा विवरण",
                english: "Details based on house ownership",
                value: "houseUsedLiving",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "घर भाडामा दिनु भएको छ कि छैन",
                english: "Based on the purpose of renting the house",
                value: "isRent",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "घरभाडा दिएको प्रयोजनको आधारमा",
                english: "Based on the purpose of renting the house",
                value: "rentGivenTo",
                title: "house",
                table: "wardWise",
            },
            // {
            // 	nepali: "सदस्यको नाम/परिवारको अन्य स्थानमा घर भएको विवरण",
            // 	english: "Details of the family's member home in another place",
            // 	value: "homeOtherPlace",
            // 	title: "house",
            // 	table: "wardWise",
            // },
            // {
            // 	nepali: "घरको स्वामित्वको आधारमा",
            // 	english: "Details based on home ownership",
            // 	value: "houseUsedLiving",
            // 	title: "house",
            // 	table: "wardWise",
            // },
            {
                nepali: "घरको बनावटको आधारमा",
                english: "Details based on home ownership",
                value: "houseType",
                title: "house",
                table: "wardWise",
            },
            // {
            //     nepali: "घरको जग कस्तो प्रकारको विवरण",
            //     english: "Details based on home ownership",
            //     value: "houseFoundation",
            //     title: "house",
            //     table: "wardWise",
            // },
            // {
            //     nepali: "घरको छानाको बनावटको आधारमा",
            //     english: "Details based on the texture of the roof",
            //     value: "rooftype",
            //     title: "house",
            //     table: "wardWise",
            // },
            {
                nepali: "घर भवन संहिता",
                english: "House building criteria",
                value: "houseCriteriaFullfill",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "घरको जोखिम प्रकारको आधारमा",
                english: "Depending on the type of home risk",
                value: "houseRiskManagement",
                title: "house",
                table: "wardWise",
            },
            // {
            //     nepali: "घरको परिवारको जोखिम पारिवारिक योजनाको विवरण",
            //     english: "Depending on the type of home risk",
            //     value: "houseRiskPlanning",
            //     title: "house",
            //     table: "wardWise",
            // },
            // {
            // 	nepali: "घर निर्माण वर्षको आधारमा विवरण",
            // 	english: "Details based on house construction year",
            // 	value: "houseRiskManagement",
            // 	title: "house",
            // 	table: "wardWise"
            // },
            {
                nepali: "घर निर्माण प्रमाण पत्र लिएको/नलिएको",
                english: "Housing certificate taken / not taken",
                value: "houseCertificate",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "घर नक्शा पास गरेको/नगरेको",
                english: "House map passed / not passed",
                value: "houseMapPass",
                title: "house",
                table: "wardWise",
            },
        ],
    },
    {
        nepali: "जग्गा सम्बन्धि विवरण",
        english: "Land Related Detail",
        value: "landReport",
        baseApiKey: "house-detail",
        child: [
            // {
            //     nepali:
            //         "परिवारको नाममा भएको  जग्गा जमिनको एकल लालपुर्जा वा संयुक्त लालपुर्जा रहेको विवरण",
            //     english: "Total land area",
            //     value: "hasLandDocument",
            //     title: "house",
            //     table: "wardWise",
            // },
            // {
            // 	nepali: "वन प्रयोजनको लागी जग्गा प्रयोग गर्नु भएको छ कि छैन ?",
            // 	english: "Total land area",
            // 	value: "isForestUse",
            // 	title: "house",
            // 	table: "wardWise",
            // },
            {
                nepali:
                    "आफ्नो वा एकाघरको परिवार सदस्यको नाममा घडेरी तथा जग्गा जमिनको विवरण",
                english: "Total land area",
                value: "ownLandOrFamilyLand",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "परिवारमा महिलाको नाममा घर, जग्गाको विवरण",
                english: "House map passed / not passed",
                value: "womenHouseOwnership",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "कृषि कार्यमा उपभोग जग्गा सम्बन्धी विवरण",
                english: "Total land area",
                value: "familyLandConsumption",
                title: "house",
                table: "wardWise",
            },
            // {
            //     nepali: "भोगचलनको आधारमा जम्मा जग्गाको विवरण",
            //     english: "Total land area",
            //     value: "totalLandArea",
            //     title: "house",
            //     table: "wardWise",
            // },
            // {
            // 	nepali: "जग्गाको भोग चलनको आधारमा घरधुरी विवरण",
            // 	english: "Total land area",
            // 	value: "elaaniNambariTotal",
            // 	title: "house",
            // 	table: "wardWise",
            // },
            {
                nepali: "कृषि कार्यका लागी जग्गा प्रयोग गर्ने घरधुरी विवरण",
                english: "Total land area",
                value: "landForAgriYesNo",
                title: "house",
                table: "wardWise",
            },
        ],
    },
    {
        nepali: "आर्थिक सम्बन्धि",
        english: "Economics Related",
        value: "economicsReport",
        baseApiKey: "house-detail",
        child: [
            // {
            //     nepali:
            //         "तपाईको परिवारले कृषिबाहेक कुनै मुख्य साना घरेलु व्यावसाय चलाएको विवरण",
            //     english: "",
            //     value: "smallHomeBusiness",
            //     title: "house",
            //     table: "wardWise",
            // },
            {
                nepali: "आम्दानीको मुख्य अंश कुन क्षेत्रमा लगानी विवरण",
                english: "",
                value: "mainIncomeInvestment",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "आम्दानीको मुख्य आम्दानीको स्रोतको विवरण",
                english: "",
                value: "mainIncomeSource",
                title: "house",
                table: "wardWise",
            },
            // {
            //     nepali: "परिवारको सरदर वार्षिक आम्दानीको विवरण",
            //     english: "",
            //     value: "annualIncome",
            //     title: "house",
            //     table: "wardWise",
            // },
            // {
            //     nepali: "परिवारको सरदर वार्षिक खर्चको विवरण",
            //     english: "",
            //     value: "annualExpense",
            //     title: "house",
            //     table: "wardWise",
            // },
            {
                nepali: "परिवारको सरदर वार्षिक आम्दानीको विवरण",
                english: "",
                value: "annualAgriIncome",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "परिवारको सरदर वार्षिक खर्चको विवरण",
                english: "",
                value: "annualAgriExpense",
                title: "house",
                table: "wardWise",
            },

            {
                nepali:
                    "परिवारमा बैंक तथा वित्तीय संस्थामा खाता भएको/नभएको विवरण",
                english:
                    "Details of family having bank or financial institution account",
                value: "bankAccountYesNo",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "बैंक खाता हुने परिवार सदस्य संख्या अनुसार विवरण",
                english:
                    "Details according to the number of family members having a bank account",
                value: "bankAccountGender",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "ऋण लिएको/नलिएको आधारमा",
                english: "",
                value: "isLoan",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "ऋण लिएको श्रोतको आधारमा",
                english: "",
                value: "loanTaken",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "ऋणलिएको  उदेश्यको आधारमा विवरण",
                english: "",
                value: "loanTakingReason",
                title: "house",
                table: "wardWise",
            },
        ],
    },
    {
        nepali: "विविध सामाजिक विवरण",
        english: "",
        value: "socialReport",
        baseApiKey: "house-detail",
        child: [
            {
                nepali:
                    "घरबाट नजिकको आधारभूत विद्यालयसम्म पुग्न कति समय लाग्नेको विवरण",
                english: "",
                value: "houseToSchool",
                title: "house",
                table: "wardWise",
            },
            {
                nepali:
                    "घरबाट नजिकको माध्यमिक विद्यालयसम्म पैदल बाट पुग्न कति समय लाग्नेको विवरण",
                english: "",
                value: "houseToSecondarySchool",
                title: "house",
                table: "wardWise",
            },
            {
                nepali:
                    "बितेको एक वर्षभित्र कुनै प्रकोपबाट तपाइँको परिवार पिडितको विवरण",
                english: "",
                value: "hasDisasterEffect",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "कुन प्रकोपबाट पिडित हुनुहुन्छ",
                english: "",
                value: "whichDisasterEffect",
                title: "house",
                table: "wardWise",
            },
            {
                nepali:
                    "परिवारबाट कोहि १८ वर्ष मुनिका बालबालिका काम गर्न घर बाहिर गएको सम्बन्धी विवरण",
                english: "",
                value: "childLabour",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "कोरोना महामारीले परिवारमा परेको असर",
                english: "",
                value: "effectFromPandemic",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "नगरपालिकाको सूचनाकेबाट प्राप्त गर्नुहुन्छ",
                english: "",
                value: "meansOfInformation",
                title: "house",
                table: "wardWise",
            },
            // {
            //     nepali:
            //         "परिवार वा टोल छिमेकमा हुने विवाद वा झैझगडाको उजुरीको विवरण",
            //     english: "",
            //     value: "complain",
            //     title: "house",
            //     table: "wardWise",
            // },
        ],
    },
    {
        nepali: "स्वास्थ्य सम्बन्धि",
        english: "Health Related",
        value: "healthReport",
        baseApiKey: "house-detail",
        child: [
            {
                nepali:
                    "गत १२ महिनामा तपाईँको परिवारबाट कसैले जिवित शिशुलाई जन्म दिनु भएको भए बच्चा जन्माउँदा कसले सहयोग गरेको विवरण",
                english: "",
                value: "helpWhileGivingBirth",
                title: "house",
                table: "wardWise",
            },
            {
                nepali:
                    "गत १२ महिनामा तपाईँको परिवारबाट कसैले जिवित शिशुलाई जन्म दिनु भएको  भए  कहाँ जन्म दिनु भयो विवरण",
                english: "",
                value: "bornWhere",
                title: "house",
                table: "wardWise",
            },
            {
                nepali: "गत १२ महिनामा परिवारबाट कसैले जिवित शिशु विवरण",
                english: "",
                value: "childBirth",
                title: "house",
                table: "wardWise",
            },
            {
                nepali:
                    "परिवारमा यस १२ महिना भित्र कोहि गर्भवती महिला हुनुहुन्छ",
                english: "",
                value: "anyPregnant",
                title: "house",
                table: "wardWise",
            },
            {
                nepali:
                    "गत १२ महिनामा तपाईँको परिवारमा गर्भवती महिलाले नियमित रूपमा तालिम प्राप्त स्वास्थ्य कर्मीहरुबाट स्वास्थ्य जाँचको विवरण",
                english: "",
                value: "pregnantCheckup",
                title: "house",
                table: "wardWise",
            },
            {
                nepali:
                    "यदि गर्भवती महिलाले नियमित रूपमा तालिम प्राप्त स्वास्थ्यकर्मीबाट स्वास्थ्य जाँच नगराएको भए, कारणको विवरण",
                english: "",
                value: "ifNotRegularCheckup",
                title: "house",
                table: "wardWise",
            },
            {
                nepali:
                    "घरबाट नजिकको स्वास्थ्य संस्थामा पैदल बाट पुग्न कति समय लाग्नेको विवरण",
                english: "",
                value: "houseToHealthPost",
                title: "house",
                table: "wardWise",
            },
            // {
            //     nepali: "घरमा बीरामी परेमा सबैभंदा पहिला जाने स्थानको आधारमा",
            //     english: "",
            //     value: "healthCheckup",
            //     title: "house",
            //     table: "wardWise",
            // },
        ],
    },
];
